import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Instance } from '@popperjs/core';
import Construction from 'images/construction.png';
import Construction2 from 'images/construction2.png';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const isMobileDevice = () => {
  return typeof window !== "undefined" && window.innerWidth < 768;
};

const ExpertiseTooltip = () => {
  const [source, setSource] = useState(Construction);
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const positionRef = React.useRef<{ x: number; y: number }>({ x: 0, y: 0 });
  const popperRef = React.useRef<Instance>(null);
  const areaRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  const handleClick = () => {
    if (isMobile) {
      setSource(Construction2);
      setOpen(prev => !prev);
    }
  };

  const handleClickAway = () => {
    if (isMobile) {
      setOpen(false);
      setSource(Construction);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Tooltip
          title={
            <div>
              <h1 style={{ display: 'flex', justifyContent: 'center', paddingBottom: '10px' }}>Expertise</h1>
              <div className="flex flex-row">
                <div className="flex-col" style={{ width: '400px', display: 'inline-block' }}>
                  <ul>
                    <li>React</li>
                    <li>Javascript</li>
                    <li>HTML</li>
                    <li>CSS</li>
                  </ul>
                </div>
                <div className="flex-col" style={{ width: '400px', display: 'inline-block' }}>
                  <ul>
                    <li>Node JS</li>
                    <li>PHP</li>
                    <li>SQL</li>
                    <li>Mongo DB</li>
                  </ul>
                </div>
              </div>
            </div>
          }
          placement="bottom"
          arrow
          open={isMobile ? open : undefined}
          disableFocusListener={isMobile}
          disableHoverListener={isMobile}
          disableTouchListener={isMobile}
          PopperProps={{
            popperRef,
            anchorEl: {
              getBoundingClientRect: () => {
                return new DOMRect(
                  positionRef.current.x,
                  areaRef.current!.getBoundingClientRect().y,
                  105,
                  50
                );
              }
            }
          }}
        >
          <Box
            ref={areaRef}
            onClick={handleClick}
            onMouseOver={() => !isMobile && setSource(Construction2)}
            onMouseOut={() => !isMobile && setSource(Construction)}
            sx={{ color: 'primary.contrastText', p: 1 }}
          >
            <img
              width="50"
              height="50"
              style={{ borderRadius: '50%', cursor: 'pointer' }}
              src={source}
              alt="Expertise"
            />
          </Box>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ExpertiseTooltip;
